<template>
  <GenericSubPanel min-height="64px">
    <template #tabs>
      <GenericTabs
        :tabs="tabs"
        @activeTab="handleActiveTab"
      />
    </template>
    <Books v-if="selectedTab === 'Books'" />
    <Professions v-if="selectedTab === 'Professions'" />
    <Boosts v-if="selectedTab === 'Boosts'" />
  </GenericSubPanel>
</template>
<script>
import { computed, ref } from "vue";
import Books from "./Books.vue";
import Professions from "./Professions.vue";
import Boosts from "./Boosts.vue";
import { useStore } from "vuex";
import GenericTabs from "../shared/GenericTabs.vue";
import GenericSubPanel from "../shared/GenericSubPanel.vue";

export default {
  components: {
    Books,
    Professions,
    Boosts,
    GenericTabs,
    GenericSubPanel,
  },
  setup() {
    const store = useStore();
    const selectedTab = ref("Boosts");

    const handleActiveTab = (tab) => {
      selectedTab.value = tab.name;
    };

    const tabs = computed(() => {
      return [
        // {
        //   name: "Lander's",
        //   selected: selectedTab.value === "Lander's",
        // },
        {
          name: "Books",
          selected: selectedTab.value === "Books",
        },
        {
          name: "Professions",
          selected: selectedTab.value === "Professions",
        },
        {
          name: "Boosts",
          selected: selectedTab.value === "Boosts",
        },
      ];
    });
    return {
      state: store.state,
      selectedTab,
      tabs,
      handleActiveTab,
    };
  },
};
</script>
